import type { ReactNode } from "react";

import { useIsMobile } from "../hooks";
import { CheckIcon, CopyIcon } from "../Icons";
import { Typo } from "../Typo";
import { useHandleCopy } from "../ReferralLinkModals";

export const BannerButtonText = ({
  icon,
  text,
  onClick,
}: {
  icon: ReactNode;
  text: string;
  onClick?: () => void;
}) => {
  const isMobile = useIsMobile();

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-[48px] w-full flex-row items-center justify-stretch gap-2 rounded-lg text-text-primary hover:bg-overlay-opacity-state-hover lg:!h-[unset] lg:p-2"
    >
      <div className="flex h-[32px] w-[32px] items-center justify-center lg:h-[18px] lg:w-[18px]">
        {icon}
      </div>
      <Typo type={isMobile ? "labelSM" : "bodySM"}>{text}</Typo>
    </button>
  );
};

export const BannerCopyButtonText = ({
  copyLabel,
  copiedLabel,
  text,
  onClick,
  iconSize = 16,
}: {
  /** Label shown when the item is idle. */
  copyLabel: string;
  /** Label shown while the "copied" feedback is active. */
  copiedLabel: string;
  /** Text written to the clipboard on click. */
  text: string;
  /**
   * Fired BEFORE the clipboard write (good place for analytics tracking).
   * The actual copy + state transition is handled internally.
   */
  onClick?: () => void;
  iconSize?: number;
}) => {
  const { copied, handleCopy } = useHandleCopy(text, onClick);

  return (
    <BannerButtonText
      icon={
        copied ? (
          <span className="text-text-positive-default">
            <CheckIcon height={iconSize} width={iconSize} />
          </span>
        ) : (
          <CopyIcon height={iconSize} width={iconSize} />
        )
      }
      text={copied ? copiedLabel : copyLabel}
      onClick={handleCopy}
    />
  );
};
